import type { RootState } from '@/rootState';

export const getUserId = ({ sharedReducer: { userData }, signInReducer: { userId } }: RootState) =>
	userData.id ?? userId;
